var kosik_prazdny = "Panier vide"; 
var kosik = "Panier";
var doprava_platba = "Livraison et paiement";
var informace = "Informations";
var heslo = "Mot de passe";
var odeslat = "Envoyer";
var zdarma = "GRATUIT";
var email = "E-mail";
var tisk ="Imprimer";
var jmeno_prijmeni = "Nom et prénom";
var pridat_koment = "Ajouter un commentaire";
var jmeno = "Nom";
var doporucene = "Nous recommandons";
var nejlev_cena = "Le moins cher";
var nejdraz_cena = "Le plus cher";
var nej_prodavane = "Les plus vendus";
var abecedne = "Alphabétiquement";
var popis = "Description";
var diskuze = "Discussion";
var napis_hledat = "Tapez ce que vous recherchez";
var koment = "Commentaire";
var obj_firma = "Commande pour entreprise";
var jina_adresa = "Livrer à une autre adresse";
var zadat_poznamku = "Saisissez une remarque pour le vendeur";
var chci_news = "Je souhaite m'inscrire à la newsletter";
var vase_poznamka = "Votre note";
var chci_reg = "Je souhaite m'inscrire";
var nakup_za = "Achetez pour ";
var doprava_text = " sur votre commande pour bénéficier";
var dopr_zdarma = " de la livraison gratuite";
var dopr_je_zdarma = "Vous avez la livraison gratuite!";
var zakaznik = "Client";
var provize_program = "Programme de partenariat";
var napis_prvni_prispevek = "Soyez le premier à écrire un commentaire.";
var prod_vyprodan = "Les produits sont épuisés";
var vysledek_hledat = "Résultats de la recherche ";
var prod_pridan_kos = "Les produits ont été ajoutés au panier.";
var prod_smazan_kos = "L'article du panier a été supprimé avec succès.";
var mnostvi_upraveno = "La quantité a été modifiée avec succès.";
var omezene_mnozstvi = "Ce produit est disponible en quantités limitées.";
var hovor_prodejce = "Parlez au vendeur";
var bez_vysledku = "Aucun résultat trouvé...";
var reg = "S'inscrire";
var cislo = "Numéro";
var doprava_a_platba = "Livraison et paiement";
var obsah_obj = "Contenu de la commande";
var zvol_doprava = "Livraison choisie";
var zvol_platba = "Paiement choisi";
var cena_zaplatit = "Montant à payer";
var hlidac_pes = "Chien de garde";
var dalsi = "Suivant";
var predchozi = "Précédent";
var zvol_variant = "Choisissez une variante";
var mate_otazky = "Vous avez des questions? Nous vous répondrons.";
var od = "À partir de";
var cena_bez_dph = "Prix hors TVA";
var bez_dph = "hors TVA";
var hodnoceni = "Évaluation";
var hlasovano = "Vous avez déjà voté";
var jak_spokojeni = "Comment êtes-vous satisfait du e-commerce?";
var odeslat_hodnoceni = "Envoyer une évaluation ";
var uloz = "Enregistrer";
var posledni = "Dernier";
var obj = "commandes";
var kusy = "Pièces";
var vloz_kupon = "Insérez un coupon de réduction";
var ks = "pcs";
var kombinace_neni = "La combinaison sélectionnée de pays, mode de livraison et de paiement n'est pas disponible.";
var info_zvol_dopravu = "Choisissez le mode de livraison.";
var info_zvol_platbu = "Choisissez le mode de paiement.";
var nazev = 'nom';
var vytvoril = 'Créé par Shoptet';
var pravavyhrazena = 'Tous droits réservés.';

var cookiesOdmitnout = 'Refuser';
var cookiesSouhlasím = 'Je suis daccord';
var cookiesNastavení = 'Paramètres';

mnozstvi_upraveno = 'La quantité a été ajustée'


$('.languagesMenu__header, .languagesMenu__list__link').each(function() {
  $(this).html(function(){
    return $(this).html().replace("Slovenčina", "Français");
  })
})



if($('html[lang="sk"]').length){

  $('input[name="vatId"]+.question-tooltip').attr('title', "N'indiquez que si vous êtes assujetti à la TVA. Le code du pays commence toujours par deux lettres. Pour la France, il s'agit de SK + 10 chiffres. L'équivalent tchèque est le numéro de TVA pour les contribuables assujettis à la TVA. Anglais -VAT number.")
  $('.id--11 #content h2').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Výsledky vyhľadávania", "Résultats de la recherche");
    });
  })
  if($('.breadcrumbs').length){
    $('span[data-title="Vyhľadávanie"]').text('Recherche')
    $('span[data-title="Klientske centrum"]').text("Centre clients");
    $('span[data-title="Nastavenie môjho účtu"]').text("Paramètres de mon compte");
    $('span[data-title="Moje objednávky"]').text("Mes commandes");
    $('span[data-title="Daňové doklady"]').text("Documents fiscaux");
    $('span[data-title="Klientske proforma faktúry"]').text("Factures clients");
    $('span[data-title="Klientske dobropisy"]').text("Notes de crédit clients");
    $('span[data-title="Dodacie listy klienta"]').text("Bons de livraison clients");
    $('span[data-title="Daňové doklady k prijatej platbe"]').text("Preuves de paiement reçues");
    $('span[data-title="Moje zľavy"]').text("Mes remises");
    $('span[data-title="Moje hodnotenia tovarov"]').text("Mes avis sur les produits");
    $('span[data-title="Moja diskusia pri tovare"]').text("Mes discussions sur les produits");
  }


  if($('.id--18').length){
    $('.content-inner').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Objednávka č.", "Numéro de commande");
      });
    })
    $('.content-inner p').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Dátum objednávky", "Date de la commande");
      });
      $(this).html(function(){
        return $(this).html().replace("Stav nákupu", "Statut d'achat");
      });
      $(this).html(function(){
        return $(this).html().replace("Rovnaká ako fakturačná", "Identique à la facturation");
      });
    })
    $('.content-inner a.btn[href*="/action/Cart/addItemsFromOrderForLoggedCustomer/"]').text('acheter à nouveau');
    $('.content-inner h2').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Detaily objednávky", "Détails de la commande");
      });
      $(this).html(function(){
        return $(this).html().replace("Údaje o zákazníkovi", "Données sur les clients");
      });
    })
    $('.content-inner h4').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Fakturačná adresa", "Adresse de facturation");
      });
      $(this).html(function(){
        return $(this).html().replace("Doručovacia adresa", "Adresse de livraison");
      });
    })

    $('.content-inner dt').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Cena celkom vrátane DPH", "Prix total incluant la TVA");
      });
      $(this).html(function(){
        return $(this).html().replace("Cena bez DPH", "Prix sans TVA");
      });
      $(this).html(function(){
        return $(this).html().replace("DPH", "TVA");
      });
    });

    $('table.table-order-details thead th').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Názov tovaru", "nom des produits");
      });
      $(this).html(function(){
        return $(this).html().replace("Množstvo", "quantité");
      });
      $(this).html(function(){
        return $(this).html().replace("Cena za m. j. bez DPH", "Prix par unité de mètre sans TVA");
      });
      $(this).html(function(){
        return $(this).html().replace("Cena za m. j. vrátane DPH", "Prix par m. j. TVA incluse");
      });
      $(this).html(function(){
        return $(this).html().replace("Zľava", "Remise");
      });
      $(this).html(function(){
        return $(this).html().replace("Cena bez DPH", "Prix sans TVA");
      });
      $(this).html(function(){
        return $(this).html().replace("Cena s DPH", "Prix avec TVA");
      });
    })
    
  }

  if($('.id--13').length){
    $('p').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Záznamy neboli nájdené...", "Aucun enregistrement trouvé...");
      })
    })
    $('select#billCountryId option').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Francúzsko", "France");
      })
    })
    
  }

  


  if($('.id--25').length){
    $('h1').text('Détails de la livraison');
    $('.content-inner>form h4').text('Adresse de livraison');
    $('label[for="deliveryCountryId"]').text('État');
    $('select#deliveryCountryId option').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Francúzsko", "France");
      })
    });
    $('input[value="Odoslať"]').attr('value', 'Envoyer à');
    $('span[data-title="Doručovacie údaje"]').text('Détails de la livraison')
  }

  $('.menu-helper').text('Plus')
  $('.breadcrumbs #navigation-first span[itemprop="name"]').text('Page daccueil')

  $('span[data-title="Prihlásenie zákazníka"]').text('Connexion')
  setTimeout(function(){
    $('a[data-testid="cookiesSettings"]').text(cookiesNastavení)
    $('button[data-testid="buttonCookiesReject"]').text(cookiesOdmitnout)
    $('button[data-testid="buttonCookiesAccept"]').text(cookiesSouhlasím)
  }, 100)
  

  if($('.id--4').length){
    $('.id--4 .content-inner h1').text('Connexion client');
    $('.password-helper a[data-testid="signup"]').text('Nouvelle inscription');
    $('.password-helper a:not([data-testid="signup"])').text('Mot de passe oublié');
    $('.btn-login').text('enregistrer')
  }
  if($('.id--8').length){
    $('#register-form>fieldset>h4').text('Confirmation');
    $('input[value="Registrovať"]').attr('value', 'Registre')
  }
  if($('.id--7').length){
    $('.content-inner h1').text('Mot de passe oublié')
    $('input[value="Odoslať"]').attr('value','Envoyer')
  }

  if($('.client-center-box').length){
    $('.client-center-box a').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Zákaznícke centrum", "Espace client");
      })
    })
  }



  
  $('#shippingAddressBox option').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Iná adresa", "Autre adresse");
    })
  })

  if($('.cart-header').length){
    $('.cart-header li').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Nákupný košík", "Panier");
      })
      $(this).html(function(){
        return $(this).html().replace("Doprava &amp;&nbsp;platba", "Livraison et paiement");
      })
      $(this).html(function(){
        return $(this).html().replace("Informácie o&nbsp;Vás", "Informations");
      })
    })
  }
  if($('.id--9').length){
    $('.cart-inner>h4').text('Cadeaux et réductions');
  }
  $('#orderFormButton, #continue-order-button').text('Continuer');
  if($('.id--16').length){
    $('.co-delivery-method, .co-payment-method').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Táto kombinácia dopravy a platby nie je možná.", "Cette combinaison d'expédition et de paiement n'est pas possible.");
      })
    })
  }

  if($('.order-summary-item').length){
    $('.order-summary-item').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Celkom za tovar:", "Total pour les marchandises :");
      })
    })
  }

  if($('.id--17').length){
    $('#submit-order').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Objednať", "Commande");
      })
      $(this).html(function(){
        return $(this).html().replace("s povinnosťou platby", "avec obligation de paiement");
      })
    })
  }

  if($('.id--15').length){
    $('h1').text('Commande envoyée');
    $('h4.order-icon.order-payment').text('Paiement et livraison');
    $('h4.order-icon.order-content').text('Contenu de la commande');
    $('.order-summary-item.total').text('Nous vous enverrons également un récapitulatif par e-mail.')
    $('.reca-number').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Číslo ", "Nombre ");
      })
    })
    $('.recapitulation-table th').each(function() {
      $(this).html(function(){
        return $(this).html().replace("Zvolená doprava", "Transport sélectionné");
      })
      $(this).html(function(){
        return $(this).html().replace("Zvolená platba", "Paiement sélectionné");
      })
      $(this).html(function(){
        return $(this).html().replace("Čiastka k úhrade", "Montant à payer");
      })
      $(this).html(function(){
        return $(this).html().replace("Bankový účet", "Compte bancaire");
      })
      $(this).html(function(){
        return $(this).html().replace("Variabilný symbol", "Symbole variable");
      })
    })
  }

  $('.search h2').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Čo potrebujete nájsť?", "Que faut-il trouver?");
    })
  })
  $('.toggle-window-arr').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Späť", "Retour");
    })
    $(this).html(function(){
      return $(this).html().replace("do obchodu", "à la e-boutique");
    })
  })
  $(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
    $("a.btn-conversion").each(function() {
      $(this).html(function(){
        return $(this).html().replace("Nákupný košík", "Panier");
      })
    })
  })
  $(".row-header-label").each(function() {
    $(this).html(function(){
      return $(this).html().replace("Kategória", "Catégorie");
    })
  })
  $('.copyright').html('Copyright '+new Date().getFullYear()+' <strong>'+$('.copyright strong').text()+'</strong>. '+pravavyhrazena)
  $('#signature a.title').text(vytvoril)
  function hkrazeni(){
    $('.category-header input[type="radio"]+label[for="order1"]').text(doporucene) /*doporučujeme*/
    $('.category-header input[type="radio"]+label[for="order2"]').text(nejlev_cena) /*Nejlevnější*/
    $('.category-header input[type="radio"]+label[for="order3"]').text(nejdraz_cena) /*Nejdražší*/
    $('.category-header input[type="radio"]+label[for="order4"]').text(nej_prodavane) /*Nejprodávanější*/
    $('.category-header input[type="radio"]+label[for="order5"]').text(abecedne) //Abecedně
  };
    hkrazeni();
  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    hkrazeni();
  });
  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    hkrazeni();
  });
  $('a[href="#description"]').text(popis); /*popis*/
  $('a[href="#productDiscussion"]').text(diskuze); /*Diskuse*/
  $('input#fullName').attr('placeholder', jmeno_prijmeni) //jmeno
  $('input#email').attr('placeholder', email) //e-mail
  $('input#title').attr('placeholder', nazev) //název 
  $('textarea#message').attr('placeholder', koment) //komentář
  $('input[type="submit"].btn[value="Send a comment"]').val(pridat_koment) /*Přidat komentář*/
  $('label[for="company-shopping"]').text(obj_firma)//objednávám na firmu
  $('label[for="another-shipping"]').text(jina_adresa)//doručit na inu adresu
  $('label[for="add-note"]').text(zadat_poznamku)//zadat poznámku pro prodejce
  $('textarea#remark').attr('placeholder', vase_poznamka) //vaše poznámka
  $('label[for="sendNewsletter"]').text(chci_news)//chcem odebírat newslettery
  $('label[for="set-registration"]').text(chci_reg) //chem se registrovat
  
  

  $('.price-label').each(function(){
    $(this).html(function(){
      return $(this).html().replace("Price vrátane DPH", cena_bez_dph);
    })
  });
  $('.availability-amount').each(function(){
    $(this).html(function(){
      return $(this).html().replace("pcs", kusy);
    })
  });

  
  $('.cart-inner.cart-empty h1').text('Votre panier est vide');
  document.addEventListener('ShoptetDOMCartContentLoaded', function() {
    $('.cart-empty h1, .cart-empty .h1').text('Votre panier est vide');
    $('.cart-empty .cart-content h4').text('Avez-vous besoin de conseils ?')

    $('div').each(function(){
      $(this).html(function(){  
        return $(this).html().replace("Objednajte ešte za", nakup_za);
      })
        $(this).html(function(){
      return $(this).html().replace(" a budete mať dopravu ", doprava_text);
      })
        $(this).html(function(){
      return $(this).html().replace("ZADARMO", dopr_zdarma);
      })
        $(this).html(function(){
      return $(this).html().replace("shipping", "");
      })
        $(this).html(function(){
      return $(this).html().replace("Dopravu máte zadarmo!", dopr_je_zdarma);
      })
    })
    $('.price-label').each(function(){
      $(this).html(function(){
        return $(this).html().replace("Price vrátane DPH", cena_bez_dph);
      })
    });
    $('.availability-amount').each(function(){
      $(this).html(function(){
        return $(this).html().replace("pcs", kusy);
      })
    });
  
  });
  $('.box-bg-default h4').each(function(){
   
    $(this).html(function(){  
      return $(this).html().replace("Bonusy", 'Bonus');
    })
  })
  $('.extra.delivery span').each(function(){
   
    $(this).html(function(){  
      return $(this).html().replace("Objednajte ešte za", nakup_za);
    })
      $(this).html(function(){
    return $(this).html().replace(" a budete mať dopravu ", doprava_text);
    })
      $(this).html(function(){
    return $(this).html().replace("ZADARMO", dopr_zdarma);
    })
      $(this).html(function(){
    return $(this).html().replace("shipping", "");
  
    })
    $(this).html(function(){
      return $(this).html().replace("Dopravu máte zadarmo!", dopr_je_zdarma);
    })
  });



  
  document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {
    $('.extra.delivery span').each(function(){
      $(this).html(function(){  
        return $(this).html().replace("Objednajte ešte za", nakup_za);
      })
        $(this).html(function(){
      return $(this).html().replace(" a budete mať dopravu ", doprava_text);
      })
        $(this).html(function(){
      return $(this).html().replace("ZADARMO", dopr_zdarma);
      })
        $(this).html(function(){
      return $(this).html().replace("shipping", "");
    
      })
      $(this).html(function(){
        return $(this).html().replace("Dopravu máte zadarmo!", dopr_je_zdarma);
      })
    });
    $('.price-label').each(function(){
      $(this).html(function(){
        return $(this).html().replace("Price vrátane DPH", cena_bez_dph);
      })
    });
    $('.availability-amount').each(function(){
      $(this).html(function(){
        return $(this).html().replace("pcs", kusy);
      })
    });
  });
  
  $('.in-step-1 span').each(function(){
  $(this).html(function(){
   return $(this).html().replace("Zadarmo", zdarma);
  })
  });
  $(document).ready(function(){
  $('label[for="company-shopping"]').attr('style', 'font-size:13px;')
  $('.in-step-1 span').each(function(){
  $(this).html(function(){
       return $(this).html().replace("Zadarmo", zdarma);
     })
  });
  })
  $(window).on('load', function(){
  $('.in-step-1 span').each(function(){
  $(this).html(function(){
     return $(this).html().replace("Zadarmo", zdarma);
   })
  });
  });
  
  $('input[type="search"].form-control').attr('placeholder', napis_hledat); /* Napište, co hledáte */
  $(document).on('ready', function() {
  $('#formSearchForm').addClass('after-hide');
  });
  
  document.addEventListener('ShoptetDOMCartContentLoaded', function() {
    $('input[type="search"].form-control').attr('placeholder', napis_hledat); /* Napište, co hledáte */
    $('#formSearchForm, #formSearchFormContent').addClass('after-hide');
  });
  
  $('input#discountCouponCode.form-control').attr('placeholder', vloz_kupon); /* Vložte slevový kupón */
  $(document).on('ready', function() {
  $('.discount-coupon').addClass('after-hide');
  });
  
  if($('input[value="Send"]').length){
  $('input[value="Send"]').val(odeslat)
  }
  
  $('.login-widget .user-action-tabs li a[href="#customerLogin"]').text(zakaznik); /*zákazník*/
  $('.login-widget .user-action-tabs li a[href="#affiliateLogin"]').text(provize_program); /*provizní program*/
  $('input[type="password"]').attr('placeholder', heslo); /*heslo*/
  $('input[type="email"]').attr('placeholder', email); /*email*/
  $('#productDiscussion p:contains("Be the first who will post an article to this item!")').text(napis_prvni_prispevek) /*první kdo napíše příspěvek*/
  $('h4.search-products-heading:contains("Produkty neboli nájdené")').text(prod_vyprodan); /*produkty byly vyprodané*/
  
  $('.in-search main#content h2').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Search results ", vysledek_hledat);
  })
  });
  
  document.addEventListener('shoptet.cart.getAdvancedOrder', function() {
  setTimeout(function(){
  $('.msg .container:contains("Položky boli pridané do nákupného košíka")').text(prod_pridan_kos).css('opacity','1'); //Produkty byly přidány do košíku
  $('.msg .container:contains("Množstvo bolo úspešne zmenené.")').text(mnozstvi_upraveno).css('opacity','1'); //Množství bylo úspěšně změneno.
  $('.msg .container:contains("Položka bola odobratá z košíka.")').text(prod_smazan_kos).css('opacity','1');//Množství bylo úspěšně smazano.
  $('.msg.msg-error .container:contains("Tento produkt má obmedzený počet kusov, ktoré je možné zakúpiť.")').text(omezene_mnozstvi).css('opacity','1'); //Tento produkt lze zakoupit v omezeném počtu kusů.
  }, 10);


  
  });
  



  if($('.id--16').length){
  document.addEventListener('ShoptetBillingMethodUpdated', function() {
    setTimeout(function(){
    $('.msg .container:contains("Vyberte spôsob dopravy")').text(info_zvol_dopravu).css('opacity','1'); //Prosím zvol dopravu.
    $('.msg .container:contains("Vyberte spôsob fakturácie")').text(info_zvol_platbu).css('opacity','1'); //Prosím zvol platbu.
  }, 10);
  });
  
  document.addEventListener('ShoptetBaseShippingInfoObtained', function() {
    setTimeout(function() {
      $('.msg .container span:contains("Vyberte spôsob dopravy")').text(info_zvol_dopravu); //Prosím zvol dopravu.
      $('.msg .container span:contains("Vyberte spôsob fakturácie")').text(info_zvol_platbu); //Prosím zvol platbu.
     // $('.msg .container').css('opacity','1');
    }, 1); // Timeout na 1ms
  });
}
  
if($('.id--9').length){
  
  $(".next-step--cart").each(function() {
    $(this).html(function(){
      return $(this).html().replace("Minimálna cena objednávky je", "Le prix minimum de la commande est de");
    })
    $(this).html(function(){
      return $(this).html().replace("bez DPH", "hors TVA");
    })
    $(this).html(function(){
      return $(this).html().replace(". Pre dokončenie objednávky je potrebné nakúpiť ešte aspoň za", ". Pour compléter la commande, vous devez acheter au moins ");
    })
    $(this).html(function(){
      return $(this).html().replace("Prosíme ", "Veuillez ");
    })
    $(this).html(function(){
      return $(this).html().replace("pokračovať v nákupe", "poursuivre vos achats");
    })
  })
 /* document.addEventListener('ShoptetDOMContentLoaded', function() {
    $('.msg').remove()
    setTimeout(function(){
      $('.msg .container:contains("Položky boli pridané do nákupného košíka")').text(prod_pridan_kos).css('opacity','1'); //Produkty byly přidány do košíku
      $('.msg .container:contains("Množstvo bolo úspešne zmenené.")').text(mnozstvi_upraveno).css('opacity','1'); //Množství bylo úspěšně změneno.
      $('.msg .container:contains("Položka bola odobratá z košíka.")').text(prod_smazan_kos).css('opacity','1');//Množství bylo úspěšně smazano.
      $('.msg.msg-error .container:contains("Tento produkt má obmedzený počet kusov, ktoré je možné zakúpiť.")').text(omezene_mnozstvi).css('opacity','1'); //Tento produkt lze zakoupit v omezeném počtu kusů.
      }, 100);
    });*/
}
 
  
  
  $('input[value="Register"]').val(reg); // Registrovat
  $('main#content p:contains("Nenašiel sa žiadny výsledok...")').text(bez_vysledku); // Nebyly nalezeny žádné výsledky
  $('.link-icon.chat').attr('title', hovor_prodejce); //hovořit s prodejcem
  
  
  if($('.in-thank-you').length){
  $('.reca-number').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Number", cislo); //Číslo
  })
  });
  $('h4').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Payment and delivery", doprava_platba); // Doručení a platba
  });
  $(this).html(function(){
  return $(this).html().replace("Obsah objednávky", obsah_obj); // Obsah objednávky
  })
  });
  $('.recapitulation-table').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Chosen delivery", zvol_doprava); //Vybraná doprava
  });
  $(this).html(function(){
  return $(this).html().replace("Chosen payment", zvol_platba); //Vybraná platba
  })
  $(this).html(function(){
  return $(this).html().replace("Price to pay", cena_zaplatit); //Částka k zaplacení
  })
  });
  }
  
  
  $('.watchdog').attr('title', hlidac_pes); // Hlídací pes
  $('.print').attr('title', tisk);
  
  $('.next-prev.text-center a:contains("Ďalej")').text(dalsi); //další šlánek
  $('.next-prev.text-center a:contains("Predchádzajúce")').text(predchozi); // předcházející článek
  $('.choose-variant.default-variant span:contains("Vyberte si variantu")').text(zvol_variant); //zvolte varintu
  $('option[data-disable-reason="Vyberte si variantu"]').text(zvol_variant);
  $('p:contains("Máte nejaké otázky?")').text(mate_otazky);
  
  $('#order-shipping-methods>div').on("click", function(){
    $('#shipping-billing-summary .recapitulation-single:not(".last") strong').each(function() {
      if($(this).text().match('Zadarmo')){
        $(this).find('span').text(zdarma)
      }
    });
  })
  $('.recapitulation-single strong').each(function() {
    if($(this).html().match('Zadarmo')){
      $(this).find('span').html(zdarma)
    }
  });
  $('#shipping-billing-summary .recapitulation-single:not(".last") strong').each(function() {
    if($(this).text().match('Zadarmo')){
      $(this).find('span').text(zdarma)
    }
  });
  $('#shipping-billing-summary .recapitulation-single .recapitulation-shipping-billing-info strong').each(function() {
    if($(this).html().match('Zadarmo')){
      $(this).find('span').html(zdarma)
    }
  });
  
  $('#shipping-billing-summary .recapitulation-single .recapitulation-shipping-billing-info span').each(function() {
    $('#shipping-billing-summary .recapitulation-single .recapitulation-shipping-billing-info span').text().replace(' Zadarmo', zdarma);
  });
  $('#shipping-billing-summary .recapitulation-single .recapitulation-shipping-billing-info span').text().replace(' Zadarmo', zdarma);
  
  if($('.in-cart').length){
  $(document).prop('title', kosik);
  }
  if($('.in-step-1').length){
  $(document).prop('title', doprava_platba);
  
  }
  if($('.in-step-2').length){
  $(document).prop('title', informace);
  }
  
  $('span').text().replace('Zadarmo', zdarma);
  
  
  $('.price-final span').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-final small').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  $('.price-additional').each(function(){
  $(this).html(function(){
  return $(this).html().replace("vrátane DPH", bez_dph);
  });
  });
  
  
  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
  $('.price-final span').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-final small').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-additional').each(function(){
    $(this).html(function(){
    return $(this).html().replace("vrátane DPH", bez_dph);
    });
  });
  });
  document.addEventListener('ShoptetPageSortingChanged', function() {
  $('.price-final span').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-final small').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-additional').each(function(){
    $(this).html(function(){
    return $(this).html().replace("vrátane DPH", bez_dph);
    });
  });
  });
  document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
  $('.price-final span').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-final small').each(function(){
  $(this).html(function(){
  return $(this).html().replace("od", od);
  });
  });
  
  $('.price-additional').each(function(){
    $(this).html(function(){
    return $(this).html().replace("vrátane DPH", bez_dph);
    });
  });
  });
  
  
  $('.stars-label').each(function(){
  $(this).html(function(){
  return $(this).html().replace("hodnotenie", hodnoceni);
  })
  $(document).ready(function(){
  $(this).html(function(){
  return $(this).html().replace("hodnotenie", hodnoceni);
  })
  })
  })
  
  $('.stars-label').each(function(){
  $(this).html(function(){
  return $(this).html().replace("hodnotenies", hodnoceni);
  })
  $(document).ready(function(){
  $(this).html(function(){
  return $(this).html().replace("hodnotenies", hodnoceni);
  })
  })
  })
  $('.stars-label').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Už ste hlasovali", hlasovano); // Už jste hlasovali
  })
  $(document).ready(function(){
  $(this).html(function(){
  return $(this).html().replace("Už ste hlasovali", hlasovano);
  })
  })
  })
  
  $('textarea[placeholder="Ako ste spokojný s obchodom?"]').attr('placeholder', jak_spokojeni);
  $('input[value="Send hodnotenie"]').attr('value', odeslat_hodnoceni);
  $('input[placeholder="Name"]').attr('placeholder', jmeno);
  $('.cart-empty .cart-content h4').text('Avez-vous besoin de conseils ?')
  $('.cart-widget-product').each(function(){
  $(this).html(function(){
  return $(this).html().replace("Pozrite sa na našu ponuku", kosik_prazdny);
  })
  })
  
  // client center
  if ($('.customer-page').length) {
  
  $('#register-form input[value="Uložiť"]').attr('value',uloz);
  
  $('.content-inner h2').each(function(){
  $(this).html(function(){
    return $(this).html().replace("Last", posledni);
  })
  $(this).html(function(){
    return $(this).html().replace("orders", obj);
  })
  })
  }
 
  $('.in-step-1 .co-delivery-method, .in-step-1 .co-payment-method').each(function(){
    $(this).html(function(){
     return $(this).html().replace("Táto kombinácia dopravy a platby nie je možná.", kombinace_neni);
    })
  });
  
  $(document).ready(function() {
    $('.availability-amount').css('opacity','1')
    $('.price-additional').css('opacity','1')
    $('.price-wrapper .price-secondary').css('opacity','1')
    $('.box.co-box.co-delivery-method').css('opacity','1')
    $('.box.co-box.co-payment-method').css('opacity','1')
  })
}

if($('.id--62, .id--61').length){
  $('.content-inner h4').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Ešte pre vás nebol vytvorený žiadny dokument.", "Aucun document n'a encore été créé pour vous.");
    })
  })
}

if($('.id--12').length){
  $('.content-inner h2').each(function() {
    $(this).html(function(){
      return $(this).html().replace("Posledné", "Les");
    })
    $(this).html(function(){
      return $(this).html().replace("objednávky", "dernières commandes");
    })
  })
}

$('.shipping-billing-summary span[data-testid="recapItemPrice"]').each(function(){
  $(this).html(function(){
    return $(this).html().replace("ZADARMO", dopr_zdarma);
    })
  })